import angular from 'angular';
import uiRouter from 'angular-ui-router';
import config from './confirm.config.js';
import { ConfirmMoveComponent } from './confirm.component';
import { MoveFormModule } from '../move-form';

export const ConfirmMoveModule = angular
  .module('app.account.moves.confirm', [MoveFormModule.name, uiRouter])
  .config(config)
  .component('updConfirmMove', ConfirmMoveComponent);
